import { useApiQuery } from 'grabbitbot-legacy-ui'
import { paymentClient } from '../api'

/** Comma-separated Stripe plan ids that count as "the base subscription" for
 * paywall purposes — legacy `environment.possibleBasePlans`, two hardcoded
 * Stripe plan ids (audit §6 "Subscriptions & payments"). Those literal ids
 * are Stripe-account-specific config, not something to hardcode/guess in
 * this rewrite; when unset, ANY plan with an active subscription satisfies
 * the gate (documented simplification — see README "Known simplifications"). */
const BASE_PLAN_IDS = (import.meta.env.VITE_BASE_PLAN_IDS || '')
  .split(',')
  .map((s: string) => s.trim())
  .filter(Boolean)

export type PaymentRequired = -1 | 0 | 1

/** Port of legacy `PaymentService.checkPayment()` (audit §6): `-1` while
 * loading, `0` once an active (`subscription.status === 1`) base-plan
 * subscription is found, `1` otherwise (paywall). */
export function usePaymentGate(): { paymentRequired: PaymentRequired; loading: boolean } {
  const { data: plans, loading } = useApiQuery(() => paymentClient.listPlans(), [])

  if (loading || !plans) return { paymentRequired: -1, loading: true }

  const hasActiveBasePlan = plans.some((plan) => {
    if (plan.subscription?.status !== 1) return false
    if (BASE_PLAN_IDS.length === 0) return true
    return plan.id != null && BASE_PLAN_IDS.includes(plan.id)
  })

  return { paymentRequired: hasActiveBasePlan ? 0 : 1, loading: false }
}
